import {Pipe, PipeTransform} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';

@Pipe({
  name: 'contractStatusPipe',
})
export class ContractStatusPipe implements PipeTransform {

  constructor (private _translocoService: TranslocoService) {}

  transform(contractStatus: 0 | 1, contractStartDate: string, returnType: string = 'contractStatus'): string {

    const currentDate = new Date();
    const startDate = new Date(contractStartDate);

      if(returnType === 'contractStatus') {
        return contractStatus === 1
          ? startDate > currentDate ? this._translocoService.translate('Contract status - (Contract control section) - Upcoming') : this._translocoService.translate('Contract status - (Contract control section) - Active')
          : this._translocoService.translate('Contract status - (Contract control section) - Inactive');
      }

      if(returnType === 'class') {
        return contractStatus === 1
          ? startDate > currentDate ? "badge badge-light-info" : "badge badge-light-success"
          : "badge badge-light-secondary";
      }

    }
}
